module.exports = __webpack_public_path__ + "public/img/yibiaopan_lv_33.3656fcb2.png";